import { COLORS, FONTS, TYPE, SPACING } from "../theme.js";

// Azure — clean corporate sans-serif with a blue accent. Section headings
// underlined with a soft blue rule. Great for white-collar / consulting roles.
export const azureStyles = {
  meta: { label: "Azure (blue corporate)" },

  page: {
    ...SPACING.pagePadding,
    backgroundColor: COLORS.white,
    fontFamily: FONTS.sans,
    fontSize: TYPE.body,
    color: COLORS.navy,
    lineHeight: 1.4,
  },

  header: {
    marginBottom: 12,
    paddingBottom: 10,
    borderBottomWidth: 2,
    borderBottomColor: COLORS.blue,
  },
  headerName: {
    fontSize: TYPE.name,
    fontFamily: FONTS.sansBold,
    color: COLORS.navy,
    letterSpacing: 0.2,
    marginBottom: 12,
  },
  headerHeadline: {
    fontSize: TYPE.headline,
    color: COLORS.blue,
    fontFamily: FONTS.sansBold,
    marginTop: 2,
    letterSpacing: 0.3,
  },
  headerContact: {
    fontSize: TYPE.micro,
    color: COLORS.slate,
    marginTop: 6,
  },
  sep: { color: COLORS.mute },

  section: { marginTop: SPACING.sectionGap },
  sectionHeadingWrap: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 6,
  },
  sectionHeading: {
    fontSize: TYPE.sectionHeading,
    fontFamily: FONTS.sansBold,
    textTransform: "uppercase",
    letterSpacing: 1.6,
    color: COLORS.blue,
    paddingRight: 8,
  },
  sectionRule: {
    flex: 1,
    height: 1,
    backgroundColor: COLORS.blueBorder,
  },

  itemGroup: { marginBottom: SPACING.itemGap },
  itemGroupTight: { marginBottom: 4 },
  itemRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  itemTitle: {
    fontSize: TYPE.itemTitle,
    fontFamily: FONTS.sansBold,
    color: COLORS.navy,
  },
  itemTitleAlt: { color: COLORS.blueDeep, fontFamily: FONTS.sansBold },
  itemTitleMuted: { fontFamily: FONTS.sans, color: COLORS.slate },
  itemSubtitle: {
    fontSize: TYPE.body,
    fontFamily: FONTS.sansItalic,
    color: COLORS.slate,
    marginTop: 1,
  },
  itemDate: { fontSize: TYPE.meta, color: COLORS.slate },

  body: { fontSize: TYPE.body, color: COLORS.navy, marginTop: 2 },
  meta: { fontSize: TYPE.meta, color: COLORS.slate, marginTop: 2 },
  chipsLine: { fontSize: TYPE.body, marginTop: 3, color: COLORS.slate },
  labelStrong: { fontFamily: FONTS.sansBold, color: COLORS.navy },
  italic: { fontFamily: FONTS.sansItalic },

  bullets: { marginTop: 4 },
  bulletRow: { flexDirection: "row", marginBottom: 2 },
  bulletMark: { width: 10, fontSize: TYPE.body, color: COLORS.blue },
  bulletText: { flex: 1, fontSize: TYPE.body, color: COLORS.navy },

  link: { color: COLORS.blueSoft, textDecoration: "underline" },
  linkSmall: {
    color: COLORS.blueSoft,
    textDecoration: "underline",
    fontSize: TYPE.meta,
  },
};
